import React, { useState } from "react";
import ModalUnroll from "../dialogs/ModalUnroll";
import { KT_COURSE_PARTICIPATION_CHANGED } from "../../utils/contestParticipationEvents";

export function courseParticipantQuery(courseId) {
  return `?course=${encodeURIComponent(courseId)}&_cb=${Date.now()}`;
}

function notifyCourseParticipationChanged(courseId) {
  try {
    window.dispatchEvent(
      new CustomEvent(KT_COURSE_PARTICIPATION_CHANGED, {
        detail: { courseId },
      })
    );
  } catch (_) {
    /* ignore */
  }
}

/**
 * Participate CTAs open `#addUserTalentModal` (Bootstrap). When already enrolled and
 * `courseParticipant` is provided, the enrolled CTA opens `ModalUnroll` instead.
 * Shared by `WidgetNewContest` and `UserDocumentWidgetItem` so markup stays in sync.
 *
 * @param {{
 *   participantQueryDone: boolean,
 *   alreadyParticipating: boolean,
 *   translate: (s: string) => string,
 *   variant?: 'banner' | 'video',
 *   courseId?: string | number,
 *   courseTitle?: string,
 *   courseParticipant?: object | null,
 * }} props
 */
export default function DashboardContestAddTalentModalCta({
  participantQueryDone,
  alreadyParticipating,
  translate,
  variant = "banner",
  courseId,
  courseTitle,
  courseParticipant,
}) {
  const [unrollModalOpen, setUnrollModalOpen] = useState(false);
  const participatingClass =
    variant === "banner"
      ? "btn mt-3 newest-contest-banner__btn newest-contest-banner__btn--participating text-3 font-weight-bold"
      : "btn newest-contest-banner__btn newest-contest-banner__btn--participating text-3 font-weight-bold";

  if (!participantQueryDone) {
    return (
      <button
        type="button"
        className="btn newest-contest-banner__btn text-3 font-weight-bold"
        disabled
        aria-busy="true"
      >
        <i className="fas fa-spinner fa-spin mr-2" aria-hidden="true" />
        {translate("Please wait...")}
      </button>
    );
  }

  if (alreadyParticipating) {
    const canUnroll =
      courseId != null && courseParticipant && courseParticipant.id != null;

    return (
      <>
        <a
          href="#"
          role="button"
          className={participatingClass}
          {...(canUnroll
            ? {
                onClick: (e) => {
                  e.preventDefault();
                  setUnrollModalOpen(true);
                },
              }
            : {
                "data-toggle": "modal",
                "data-target": "#addUserTalentModal",
                onClick: (e) => e.preventDefault(),
              })}
        >
          <i className="fas fa-check-circle mr-2" aria-hidden="true" />
          {translate("You are participating")}
        </a>
        {canUnroll && (
          <ModalUnroll
            course={courseId}
            courseTitle={courseTitle}
            courseParticipant={courseParticipant}
            isOpen={unrollModalOpen}
            setIsOpen={setUnrollModalOpen}
            onSuccess={() => {
              setUnrollModalOpen(false);
              notifyCourseParticipationChanged(courseId);
            }}
          />
        )}
      </>
    );
  }

  return (
    <a
      href="#"
      role="button"
      className="btn newest-contest-banner__btn text-3 font-weight-bold"
      data-toggle="modal"
      data-target="#addUserTalentModal"
      onClick={(e) => e.preventDefault()}
    >
      <i className="fas fa-trophy mr-2" aria-hidden="true" />
      {translate("Participate")}
    </a>
  );
}
